import ScrollToTop from '../Components/ScrollToTop';
import HeroSection2 from '../Components/HeroSection2/index2';
import Footer from '../Components/Footer/Footer';

const Menu = () => {
  return (
    <>
      <ScrollToTop />
      <HeroSection2 />
      <Footer />
    </>
  )
}

export default Menu